import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Blog from './components/Blog';
import BlogPost from './components/BlogPost';
import Courses from './components/Courses';
import { motion } from "framer-motion";
import Bookshelf from './components/Bookshelf';

function AppContent({ toggleTheme, theme }) {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <div className={`flex flex-col min-h-screen bg-background text-text font-sans dark:bg-dark-background dark:text-dark-text border-none ${isHome ? 'h-screen overflow-hidden' : ''}`}>
      <Navbar toggleTheme={toggleTheme} theme={theme} />
      <motion.main
        className="flex-grow flex flex-col"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/skills" element={<Skills />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/bookshelf" element={<Bookshelf />} />
        </Routes>
      </motion.main>
    </div>
  );
}

function App() {
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  useEffect(() => {
    const root = window.document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  return (
    <Router>
      <AppContent toggleTheme={toggleTheme} theme={theme} />
    </Router>
  );
}

export default App;
